import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'
import InstagramIcon from '@/icons/InstagramIcon.vue'
import FacebookIcon from '@/icons/FacebookIcon.vue'
import TwitterIcon from '@/icons/TwitterIcon.vue'
import WhatsappIcon from '@/icons/WhatsappIcon.vue'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#f2613f'
  },
  icons: {
    instagram: {
      component: InstagramIcon
    },
    facebook: {
      component: FacebookIcon
    },
    twitter: {
      component: TwitterIcon
    },
    whatsapp: {
      component: WhatsappIcon
    }
  }
})
